{
  "saveHint": "اضغط {{shortcut}} للحفظ",
  "leave": {
    "title": "تجاهل التغييرات غير المحفوظة؟",
    "body": "لديك تغييرات في هذه الصفحة لم تُحفظ بعد.",
    "confirm": "تجاهل التغييرات",
    "cancel": "متابعة التعديل"
  },
  "errors": {
    "ownRoles": "لا يمكنك تغيير أدوارك بنفسك. اطلب ذلك من مسؤول آخر.",
    "disableSelf": "لا يمكنك تعطيل حسابك.",
    "lastAdministrator": "يجب أن يحتفظ مستخدم نشط واحد على الأقل بصلاحية المسؤول الكاملة. امنح مستخدمًا آخر الصلاحية الكاملة أولًا.",
    "useChangePassword": "لتغيير كلمة مرورك، استخدم «تغيير كلمة المرور» في قائمة حسابك.",
    "systemRole": "لا يمكن إعادة تسمية أدوار النظام أو حذفها أو تغيير صلاحياتها.",
    "grantFullAccess": "لا يمنح صلاحية المسؤول الكاملة إلا مستخدم يملك كل الصلاحيات.",
    "grantMissing": "يمكنك منح الصلاحيات التي تملكها فقط. لا تملك: {{list}}.",
    "userHasMoreAccess": "لدى هذا المستخدم صلاحيات لا تملكها، لذا لا يمكنك تعديل حسابه.",
    "scopeNotGrantable": "يمكنك منح الوصول إلى السجلات التي تصل إليها بنفسك فقط. ضيّق النطاق أو اطلب ذلك من مدير يصل إلى هذه السجلات.",
    "adminScopeMustBeAll": "الدور الذي يملك كل الصلاحيات يصل دائمًا إلى كل السجلات. أبقِ نطاقه «كل البيانات».",
    "scopeUnitUnavailable": "إحدى الوحدات التنظيمية المختارة مؤرشفة أو لم تعد موجودة. اختر وحدة أخرى.",
    "inviteDisabledUser": "فعّل المستخدم قبل إرسال الدعوة.",
    "invitationNotOpen": "لا توجد دعوة مفتوحة لسحبها. ربما قُبلت أو سُحبت أو استُبدلت."
  },
  "users": {
    "title": "المستخدمون",
    "subtitle": "الأشخاص الذين يمكنهم الدخول إلى هذه الشركة، وما يمكنهم فعله.",
    "new": "مستخدم جديد",
    "newTitle": "مستخدم جديد",
    "newSubtitle": "يدخل المستخدم بهذا البريد الإلكتروني وكلمة المرور الأولية، ثم يختار كلمة مروره.",
    "create": "إنشاء المستخدم",
    "save": "حفظ المستخدم",
    "moreActions": "إجراءات أخرى",
    "changeOwnPassword": "تغيير كلمة مرورك",
    "searchLabel": "البحث في المستخدمين",
    "searchPlaceholder": "ابحث بالاسم أو البريد الإلكتروني…",
    "clearSearch": "مسح البحث",
    "statusFilter": "التصفية حسب الحالة",
    "allStatuses": "كل الحالات",
    "roleFilter": "التصفية حسب الدور",
    "allRoles": "كل الأدوار",
    "clearFilters": "مسح عوامل التصفية",
    "noRoles": "بلا أدوار",
    "neverSignedIn": "لم يدخل بعد",
    "empty": {
      "title": "لا يوجد مستخدمون بعد.",
      "filteredTitle": "لا يوجد مستخدمون مطابقون.",
      "filteredBody": "جرّب اسمًا أو بريدًا آخر، أو امسح عوامل التصفية."
    },
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "locale": "اللغة",
      "roles": "الأدوار",
      "status": "الحالة",
      "password": "كلمة المرور الأولية",
      "lastLoginAt": "آخر دخول",
      "createdAt": "تاريخ الإنشاء",
      "updatedAt": "آخر تعديل"
    },
    "status": {
      "ACTIVE": "نشط",
      "DISABLED": "معطّل",
      "LOCKED": "مقفل",
      "PASSWORD_PENDING": "بانتظار تغيير كلمة المرور"
    },
    "sections": {
      "account": "الحساب",
      "access": "الصلاحيات",
      "password": "كلمة المرور الأولية",
      "activity": "نشاط الدخول",
      "signIn": "طريقة الدخول"
    },
    "hints": {
      "email": "يُستخدم لتسجيل الدخول، ويجب ألا يكون لمستخدم آخر.",
      "locale": "اللغة التي يفتح بها التطبيق لهذا المستخدم.",
      "access": "تحدد الأدوار الشاشات والإجراءات المتاحة للمستخدم.",
      "ownRoles": "لا يمكنك تغيير أدوارك. اطلب ذلك من مسؤول آخر.",
      "rolesUnavailable": "تعذّر تحميل الأدوار، لذا لا يمكن تغييرها هنا.",
      "ownStatus": "لا يمكنك تعطيل حسابك.",
      "status": "لا يستطيع المستخدم المعطّل الدخول، ويُسجَّل خروجه من كل مكان.",
      "initialPassword": "سلّم كلمة المرور هذه للمستخدم. عليه تغييرها في أول مرة يدخل فيها.",
      "passwordLength": "10 أحرف على الأقل."
    },
    "rolesPlaceholder": "اختر الأدوار",
    "rolesSearch": "ابحث في الأدوار…",
    "rolesEmpty": "لا توجد أدوار.",
    "rolesClear": "مسح الاختيار",
    "rolesSelected": "{{n}} أدوار",
    "showPassword": "إظهار كلمة المرور",
    "hidePassword": "إخفاء كلمة المرور",
    "generatePassword": "إنشاء كلمة مرور",
    "lockedTitle": "هذا الحساب مقفل",
    "lockedBody": "محاولات دخول فاشلة كثيرة. يُفتح تلقائيًا بعد بضع دقائق، أو يمكنك فتحه الآن.",
    "selfNotice": "هذا حسابك. يمكنك تعديل بياناتك هنا، أما الأدوار والحالة فيغيّرها مسؤول آخر.",
    "errors": {
      "emailTaken": "هذا البريد الإلكتروني مستخدم لمستخدم آخر.",
      "notCreated": "لم يُنشأ المستخدم",
      "notSaved": "لم يُحفظ المستخدم"
    },
    "conflict": {
      "title": "عدّل شخص آخر هذا المستخدم",
      "body": "لم تُحفظ تغييراتك. أعد التحميل لعرض أحدث نسخة، ثم أعد إجراء تغييراتك.",
      "reload": "تحميل أحدث نسخة"
    },
    "toast": {
      "created": "يمكن لـ{{name}} الدخول الآن",
      "createdBody": "سيُطلب منه اختيار كلمة مرور خاصة به.",
      "updated": "تم حفظ المستخدم",
      "invited": "تمت إضافة {{name}}",
      "invitedBody": "رسالة الدعوة إلى {{email}} في قائمة الانتظار. تظهر حالة إرسالها في صفحته.",
      "inviteFailed": "أُضيف {{name}}، لكن الدعوة لم تُرسل",
      "scopeNotEnforced": "النطاق لا يقيّد السجلات بعد",
      "scopeNotEnforcedBody": "تقتصر النطاقات حاليًا على المشتريات والمشاريع ومستندات المبيعات، فيبقى الوصول إلى كل السجلات متاحًا عبر: {{roles}}. ويظل النطاق مقيِّدًا عند تعديل الهيكل التنظيمي وعند منح المستخدمين الصلاحيات أو إدارتهم."
    },
    "reset": {
      "action": "إعادة تعيين كلمة المرور",
      "title": "إعادة تعيين كلمة مرور {{name}}؟",
      "body": "يُسجَّل خروجه من كل مكان، وعليه اختيار كلمة مرور جديدة عند دخوله التالي بهذه الكلمة.",
      "password": "كلمة المرور المؤقتة",
      "confirm": "إعادة تعيين كلمة المرور",
      "done": "أُعيد تعيين كلمة مرور {{name}}",
      "doneBody": "سلّمه كلمة المرور المؤقتة؛ وسيختار كلمة مروره عند الدخول."
    },
    "unlock": {
      "action": "فتح الحساب",
      "title": "فتح حساب {{name}}؟",
      "body": "يمكنه محاولة الدخول مرة أخرى فورًا.",
      "done": "تم فتح حساب {{name}}"
    },
    "scope": {
      "title": "السجلات التي يصل إليها كل دور",
      "hint": "قيّد الدور بوحدة تنظيمية وما يتبعها، أو بالسجلات المسندة إلى المستخدم، أو بسجلاته الخاصة. تقتصر النطاقات حاليًا على المشتريات والمشاريع ومستندات المبيعات، وتبقى الصلاحيات الأخرى تصل إلى كل السجلات.",
      "kindFor": "السجلات التي يصل إليها {{role}}",
      "unitsFor": "الوحدات التنظيمية لـ{{role}}",
      "kinds": {
        "ALL": "كل البيانات",
        "ORG_SUBTREE": "وحدة وما يتبعها",
        "ASSIGNED": "المسند إليه فقط",
        "OWN": "الخاص به فقط"
      },
      "explain": {
        "ALL": "كل السجلات.",
        "ORG_SUBTREE": "مشتريات الوحدات المختارة والوحدات التابعة لها ومشاريعها ومستندات مبيعاتها.",
        "ASSIGNED": "المشتريات والمشاريع المسندة إلى المستخدم أو التي يشارك فيها فقط، دون مستندات المبيعات.",
        "OWN": "المشتريات والمشاريع ومستندات المبيعات التي أنشأها المستخدم والمشاريع التي يديرها فقط."
      },
      "adminAll": "صلاحية مدير النظام الكاملة تصل دائمًا إلى كل السجلات.",
      "notEnforced": "لا تقيّد النطاقات أيًّا من صلاحيات هذا الدور بعد، فيبقى يصل إلى كل السجلات. ويظل النطاق مقيِّدًا عند تعديل الهيكل التنظيمي وعند منح المستخدمين الصلاحيات أو إدارتهم.",
      "unitsPlaceholder": "اختر الوحدات التنظيمية",
      "unitsSearch": "ابحث في الوحدات التنظيمية…",
      "unitsEmpty": "لا توجد وحدة تنظيمية مطابقة",
      "unitsClear": "مسح الوحدات",
      "unitsSelected": "{{n}} وحدات",
      "unitRequired": "اختر وحدة تنظيمية واحدة على الأقل.",
      "archivedUnit": "{{name}} (مؤرشفة)"
    },
    "access": {
      "title": "الوصول إلى البيانات",
      "hint": "السجلات التي تصل إليها أدوار المستخدم.",
      "everything": "يملك صلاحية مدير النظام الكاملة: كل الصلاحيات على كل السجلات.",
      "noRoles": "لا أدوار، فلا وصول إلى أي سجلات.",
      "rolesLabel": "الأدوار والسجلات التي تصل إليها",
      "subtreeOf": "{{units}} وما يتبعها",
      "nothing": "لا سجلات",
      "moduleOff": "الوحدة متوقفة",
      "moduleOffHint": "وحدتها متوقفة. يُحتفظ بالنطاق ويعود العمل به عند إعادة تشغيل الوحدة.",
      "byPermission_zero": "حسب الصلاحية ({{count}})",
      "byPermission_one": "حسب الصلاحية ({{count}})",
      "byPermission_two": "حسب الصلاحية ({{count}})",
      "byPermission_few": "حسب الصلاحية ({{count}})",
      "byPermission_many": "حسب الصلاحية ({{count}})",
      "byPermission_other": "حسب الصلاحية ({{count}})",
      "permissionsLabel": "السجلات التي تصل إليها كل صلاحية",
      "permission": "الصلاحية",
      "reaches": "يصل إلى",
      "unavailable": "تعذر تحميل الوصول إلى البيانات.",
      "notNarrowed": "لا تقيّدها النطاقات",
      "notApplied": "لا يقيّد السجلات بعد",
      "notAppliedHint": "تقتصر النطاقات حاليًا على المشتريات والمشاريع ومستندات المبيعات. لا يتقيّد أيٌّ من صلاحيات هذا الدور بنطاقه، فيبقى يصل إلى كل السجلات. ويظل النطاق مقيِّدًا عند تعديل الهيكل التنظيمي وعند منح المستخدمين الصلاحيات أو إدارتهم.",
      "invite": {
        "label": "إرسال دعوة بالبريد الإلكتروني",
        "body": "يصله رابط ليختار كلمة مرور خاصة به. يعمل الرابط لمدة 3 أيام.",
        "unavailable": "غير متاح: البريد الإلكتروني غير مُعد لهذه الشركة، فلا يمكن إرسال الدعوة.",
        "setUp": "أعدّ البريد الإلكتروني لتتمكن من دعوة الأشخاص بالبريد.",
        "askAdmin": "اطلب من المسؤول إعداد البريد الإلكتروني لتتمكن من دعوة الأشخاص بالبريد.",
        "openSettings": "فتح إعدادات البريد"
      },
      "password": {
        "label": "تعيين كلمة مرور الآن",
        "body": "تسلّمه كلمة المرور بنفسك، ويغيّرها عند أول تسجيل دخول."
      }
    },
    "invite": {
      "action": "إرسال دعوة بالبريد",
      "title": "إرسال دعوة إلى {{name}}؟",
      "body": "تُرسل رسالة إلى {{email}} فيها رابط لاختيار كلمة مرور جديدة. يتوقف أي رابط سابق عن العمل، وتتوقف كلمة المرور الحالية عند تعيين الجديدة.",
      "confirm": "إرسال الدعوة",
      "done": "الدعوة إلى {{email}} في قائمة الانتظار"
    },
    "invitation": {
      "title": "الدعوة",
      "loading": "جارٍ تحميل الدعوة…",
      "loadFailed": "تعذّر تحميل الدعوة.",
      "reload": "تحديث",
      "sentTo": "إلى",
      "addressRemoved": "أُزيل العنوان",
      "recipientRemoved": "أُزيلت بيانات المستلم",
      "state": {
        "PENDING": "في الانتظار",
        "SENT": "أُرسلت",
        "FAILED": "لم تُرسل",
        "EXPIRED": "منتهية",
        "ACCEPTED": "مقبولة",
        "REVOKED": "مسحوبة"
      },
      "detail": {
        "PENDING": "الرسالة في الطريق. قد يستغرق التسليم بضع دقائق.",
        "SENT": "أُرسلت الرسالة. يعمل الرابط حتى {{date}}.",
        "FAILED": "تعذّر إرسال الرسالة: {{reason}}. لم يصله الرابط.",
        "EXPIRED": "انتهت صلاحية الرابط في {{date}} قبل استخدامه.",
        "ACCEPTED": "عيّن كلمة المرور الخاصة به في {{date}}.",
        "REVOKED": "سُحبت في {{date}}. لم يعد الرابط يعمل."
      },
      "fixThenResend": "عالج سبب التوقف، ثم أرسل الدعوة مرة أخرى.",
      "stillQueued": "لا تزال في الانتظار. قد يستغرق التسليم وقتًا أطول؛ تحقق لاحقًا.",
      "resend": "إرسال مرة أخرى",
      "revoke": "سحب الدعوة",
      "revokeTitle": "سحب الدعوة؟",
      "revokeBody": "يتوقف الرابط عن العمل فورًا. يمكنك إرسال دعوة جديدة لاحقًا.",
      "revoked": "سُحبت الدعوة"
    }
  },
  "roles": {
    "title": "الأدوار",
    "subtitle": "مجموعات صلاحيات تمنحها للمستخدمين.",
    "new": "دور جديد",
    "newTitle": "دور جديد",
    "newSubtitle": "سمِّ الدور واختر ما يستطيع مستخدموه فعله.",
    "save": "حفظ الدور",
    "moreActions": "إجراءات أخرى",
    "empty": "لا توجد أدوار بعد.",
    "fullAccess": "صلاحية كاملة",
    "system": "نظام",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "description": "الوصف",
      "descriptionAr": "الوصف بالعربية",
      "access": "الصلاحيات",
      "users": "المستخدمون"
    },
    "permissionCount": "{{chosen}} من {{total}} صلاحية",
    "accessSummary": "اختيرت {{chosen}} من {{total}} صلاحية.",
    "groupCount": "{{chosen}} من {{total}}",
    "selectAllIn": "تحديد الكل في {{group}}",
    "lockedPermission": "يمكنك منح الصلاحيات التي تملكها فقط.",
    "moduleOff": "هذه الوحدة متوقفة لشركتك؛ تسري هذه الصلاحيات عند إعادة تشغيلها.",
    "usersCount_zero": "لا مستخدمين",
    "usersCount_one": "مستخدم واحد",
    "usersCount_two": "مستخدمان",
    "usersCount_few": "{{n}} مستخدمين",
    "usersCount_many": "{{n}} مستخدمًا",
    "usersCount_other": "{{n}} مستخدم",
    "showUsers": "عرض المستخدمين الذين لديهم {{name}}",
    "sections": {
      "details": "التفاصيل",
      "access": "الصلاحيات"
    },
    "hints": {
      "systemName": "تحتفظ أدوار النظام بأسمائها.",
      "grantable": "الصلاحيات التي لا تملكها مقفلة."
    },
    "systemNotice": "هذا دور نظام: اسمه وصلاحياته ثابتة. يمكنك تغيير الاسم بالعربية والوصف.",
    "systemDescription": "دور مدمج يملك كل الصلاحيات ولا يمكن حذفه.",
    "fullAccessTitle": "صلاحية كاملة",
    "fullAccessBody": "لهذا الدور كل الصلاحيات، بما فيها ما يُضاف في الإصدارات القادمة.",
    "errors": {
      "nameTaken": "يوجد دور بهذا الاسم بالفعل.",
      "notSaved": "لم يُحفظ الدور"
    },
    "conflict": {
      "title": "عدّل شخص آخر هذا الدور",
      "body": "لم تُحفظ تغييراتك. أعد التحميل لعرض أحدث نسخة، ثم أعد إجراء تغييراتك.",
      "reload": "تحميل أحدث نسخة"
    },
    "toast": {
      "created": "تم إنشاء الدور",
      "updated": "تم حفظ الدور",
      "deleted": "تم حذف الدور"
    },
    "delete": {
      "action": "حذف الدور",
      "title": "حذف {{name}}؟",
      "body": "يُحذف الدور نهائيًا. لا يوجد مستخدمون لديهم هذا الدور.",
      "confirm": "حذف الدور",
      "inUseTitle": "{{name}} مستخدَم",
      "inUseBody_zero": "لا يوجد مستخدمون لديهم هذا الدور.",
      "inUseBody_one": "لدى مستخدم واحد هذا الدور. أزله منه قبل الحذف.",
      "inUseBody_two": "لدى مستخدمَين هذا الدور. أزله منهما قبل الحذف.",
      "inUseBody_few": "لدى {{n}} مستخدمين هذا الدور. أزله منهم قبل الحذف.",
      "inUseBody_many": "لدى {{n}} مستخدمًا هذا الدور. أزله منهم قبل الحذف.",
      "inUseBody_other": "لدى {{n}} مستخدم هذا الدور. أزله منهم قبل الحذف.",
      "close": "إغلاق",
      "showUsers": "عرض المستخدمين"
    },
    "prerequisites": {
      "title_zero": "{{count}} صلاحية لن تعمل وحدها",
      "title_one": "صلاحية لن تعمل وحدها",
      "title_two": "صلاحيتان لن تعملا وحدهما",
      "title_few": "{{count}} صلاحيات لن تعمل وحدها",
      "title_many": "{{count}} صلاحية لن تعمل وحدها",
      "title_other": "{{count}} صلاحية لن تعمل وحدها",
      "item": "«{{permission}}» تحتاج إلى {{missing}}",
      "and": " و",
      "or": " أو ",
      "add_zero": "إضافة {{count}} صلاحية ناقصة",
      "add_one": "إضافة الصلاحية الناقصة",
      "add_two": "إضافة الصلاحيتين الناقصتين",
      "add_few": "إضافة {{count}} صلاحيات ناقصة",
      "add_many": "إضافة {{count}} صلاحية ناقصة",
      "add_other": "إضافة {{count}} صلاحية ناقصة",
      "stamp": "نواقص",
      "listHint": "بعض صلاحياته تحتاج إلى صلاحيات أخرى لا يملكها. افتح الدور لاستكمالها."
    }
  }
}
